import React from 'react';
import { Document } from '@react-pdf/renderer';
import { PrintDataFields } from '@repo/print-pdf/arbre/print';

import { EpaysagePDF } from '../one';

interface MultiPDFDocumentProps {
  printDataList: PrintDataFields[];
  epaysageIds: number[];
}

export const MultiEpaysagePDFDocument: React.FC<MultiPDFDocumentProps> = ({
  printDataList,
  epaysageIds,
}) => {

  const renderFiche = (data: PrintDataFields, inventaireId: number) => {

    return (
      <>
        <EpaysagePDF data={data as any} epaysageId={inventaireId} essences={(data as any).essence || []} />
      </>
    );
  };

  return (
    <Document>
      {printDataList.map((data, index) => renderFiche(data, epaysageIds[index] || index))}
    </Document>
  );
};

